/* Socle du thème parent : bootstrap global et gestionnaire de chunks.
   GB ne charge plus le app.js du parent : un seul runtime webpack et un seul
   gestionnaire de chunks sur la page. */
import bootstrap from '../../../../musees-de-sete/resources/assets/scripts/core/bootstrap.js';
import chunks from '../../../../musees-de-sete/resources/assets/scripts/core/chunks.js';
import Lenis from 'lenis';

/* Spécifique Georges Brassens */
import gbChunks from './chunks.js';
import header from './header.js';

const App = {
    init() {
        // initialisation des événements et librairies globales
        bootstrap.init();

        // initialisation de Lenis pour smooth scrolling
        window.lenis = new Lenis({
            autoRaf: true,
        });

        // registre du parent complété / surchargé par les chunks GB
        chunks.register(gbChunks);
        chunks.init();

        header.init();
    },
};

// Appel de la fonction d'initialisation
App.init();
